import {GitHubAvatar} from '@github-ui/github-avatar'
import {commitPath} from '@github-ui/paths'
import {Label, Link} from '@primer/react'
import {useLayoutQuery} from '../../page-data/loaders/use-layout-query'
import {shortOid} from '../toolbar/timeline-panel/issue-events/short-oid'
import type {PullRequestArtifact} from './use-pull-request-artifacts'
import styles from './ArtifactMetadata.module.css'

export const ArtifactMetadata = ({artifact}: {artifact: PullRequestArtifact}) => {
  const {repository} = useLayoutQuery().data
  const {creator, requested_by: requestedBy, commit_oid: commitOid} = artifact
  const timestamp = artifact.updated_at ?? artifact.created_at

  return (
    <div className={styles.Metadata} data-testid="artifact-metadata">
      <p className={styles.Attribution}>
        {creator ? (
          <span className={styles.Actor}>
            {creator.avatar_url && <GitHubAvatar src={creator.avatar_url} alt="" size={16} square={creator.is_bot} />}
            <span>
              Added by <span className={styles.Login}>{creator.login}</span>
            </span>
            {creator.is_bot && <Label variant="secondary">bot</Label>}
          </span>
        ) : (
          <span>Unknown creator</span>
        )}
        {requestedBy && <span>on behalf of {requestedBy.login}</span>}
        {timestamp && (
          <span>
            <span aria-hidden="true">· </span>
            updated{' '}
            <time dateTime={timestamp}>
              {new Date(timestamp).toLocaleString('en', {
                dateStyle: 'medium',
                timeStyle: 'long',
                timeZone: 'UTC',
              })}
            </time>
          </span>
        )}
      </p>
      {commitOid && (
        <dl className={styles.Details} aria-label="Artifact details">
          <div className={styles.Detail}>
            <dt className={styles.DetailLabel}>Commit</dt>
            <dd className={styles.DetailValue}>
              <Link
                inline
                className={styles.Sha}
                href={commitPath({owner: repository.ownerLogin, repo: repository.name, commitish: commitOid})}
              >
                {shortOid(commitOid)}
              </Link>
            </dd>
          </div>
        </dl>
      )}
    </div>
  )
}
